import { defineMessages } from 'react-intl'

const scope = `procurify.components.DataTable.APItemDescriptionCell`

export default defineMessages({
  skuLabel: {
    id: `${scope}.skuLabel`,
    defaultMessage: 'sku: {sku}',
  },
})
